// src/components/Footer.js
import { Link } from "react-router-dom";
//import {Satellite, Mail, MapPin, Phone, ExternalLink, BookOpen, Users, Smartphone} from "lucide-react";
import { Satellite, Mail, MapPin, Phone, Printer, ExternalLink, Github, Twitter, Linkedin, BookOpen, Users, Smartphone } from "lucide-react";
import { API_URLS } from "../config";

/* ── Update this URL with the exact Play Store app link ── */
const PLAY_STORE_URL =
  "https://play.google.com/store/search?q=Smart+Weather+paskariUg&c=apps";

const LINKS = {
  monitoring: [
    { label: "TEC Dashboard",            to: "/products/dashboardtec" },
    { label: "Scintillation Monitor",     to: "/products/scintillation" },
    { label: "Weather Forecasting",       href: API_URLS.weatherApp, platform: true },
    { label: "Space Weather Products",    href: API_URLS.spaceApp,   platform: true },
    { label: "Live Alerts",               to: "/alerts" },
  ],
  research: [
    { label: "Publications",   to: "/publications" },
    { label: "Data Portal",    to: "/data" },
    { label: "Partners",       to: "/partners" },
    { label: "Education",      to: "/education" },
    { label: "Resources",      to: "/resources" },
  ],
  community: [
    { label: "Aviation Operators",         to: "/community#aviation" },
    { label: "GPS & GNSS Users",           to: "/community#gnss" },
    { label: "Power Grid Operators",       to: "/community#power" },
    { label: "HF Radio Professionals",    to: "/community#hf-radio" },
    { label: "Emergency Managers",         to: "/community#disaster" },
  ],
  external: [
    { label: "Faculty of Science Education",           href: "https://fse.busitema.ac.ug/" },
    { label: "SANSA",               href: "https://www.sansa.org.za/" },
    //{ label: "EUMETSAT",            href: "https://www.eumetsat.int/" },
    { label: "IGS",                 href: "https://igs.org/" },
    //{ label: "Busitema University", href: "https://www.busitema.ac.ug/" },
    { label: "DMS",         href: "https://www.mwe.go.ug/about/departments/meteorological-services" },
  ],
};

const SHOW_SOCIAL_LINKS = false;

export default function Footer() {
  return (
    <footer
      style={{
        background:  'var(--footer-bg)',
        borderTop:   '1px solid var(--footer-border)',
        color:       'var(--footer-title)',
      }}
    >
      {/* ── Main footer grid ── */}
      <div className="section-container py-12">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 xl:grid-cols-5 gap-10">

          {/* ── Branding column ── */}
          <div className="xl:col-span-2 sm:col-span-2">
            <div className="flex items-center gap-3 mb-4">
              <img src="/swt_logo.png" alt="SWT" className="h-12 w-auto" />
              <div>
                <div style={{ fontSize: 'var(--text-sm)', fontWeight: 800, color: 'var(--footer-title)', lineHeight: 1.2 }}>
                  Space Weather Early Warning Tool
                </div>
                <div style={{ fontSize: 'var(--text-xs)', color: 'var(--footer-text)', marginTop: '2px' }}>
                  Busitema University, Uganda
                </div>
              </div>
            </div>

            <p style={{ color: 'var(--footer-text)', fontSize: 'var(--text-sm)', lineHeight: 1.7, marginBottom: '20px', maxWidth: '24rem' }}>
              A national initiative funded by the Government of Uganda under the Office of the President. We monitor and forecast space based weather phenomena.
            </p>

            {/* Live status pill */}
            {/*<div
              className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full text-xs font-semibold mb-5"
              style={{
                background: 'var(--status-safe-bg)',
                border:     '1px solid var(--status-safe)',
                color:      'var(--status-safe)',
              }}
            >
              <span className="pulse-dot" style={{ width: '8px', height: '8px' }} />
              Services Online — East Africa Coverage Active
            </div> */}

          {/* Contact info */}
          <ul className="space-y-2" style={{ fontSize: 'var(--text-sm)', color: 'var(--footer-text)' }}>
            <li className="flex items-start gap-2">
              <MapPin size={14} className="mt-0.5 shrink-0 text-green-400" />
              Dept. of Physics, Faculty of Science and Education, Busitema University, P.O Box 236 Tororo, Uganda
            </li>
            <li className="flex items-center gap-2">
              <Mail size={14} className="shrink-0 text-green-400" />
              <a href="mailto:space.sci@busitema.ac.ug" className="footer-link">
                space.sci@busitema.ac.ug
              </a>
            </li>
            <li className="flex items-center gap-2">
              <Mail size={14} className="shrink-0 text-green-400" />
              <a href="mailto:swt@busitema.ac.ug" className="footer-link">
                swt@busitema.ac.ug
              </a>
            </li>
            <li className="flex items-center gap-2">
              <Phone size={14} className="shrink-0 text-green-400" />
              Tel: +256 454448071
            </li>
            <li className="flex items-center gap-2">
              <Printer size={14} className="shrink-0 text-green-400" />
              Fax: +256 4544365147
            </li>
          </ul>

            {/* Mobile App badge + QR */}
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: "0.75rem",
                marginTop: "1.25rem",
              }}
            >
              {/* Play Store badge */}
              <a
                href={PLAY_STORE_URL}
                target="_blank"
                rel="noopener noreferrer"
                style={{
                  display: "inline-flex",
                  alignItems: "center",
                  gap: "0.6rem",
                  padding: "0.55rem 1rem",
                  background: "rgba(255,255,255,0.06)",
                  border: "1px solid rgba(255,255,255,0.14)",
                  borderRadius: "10px",
                  textDecoration: "none",
                  transition: "all 0.2s ease",
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.background = "rgba(0,128,0,0.18)";
                  e.currentTarget.style.borderColor = "rgba(0,200,0,0.35)";
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.background = "rgba(255,255,255,0.06)";
                  e.currentTarget.style.borderColor = "rgba(255,255,255,0.14)";
                }}
              >
                <Smartphone size={22} color="#4ade80" />
                <div>
                  <div
                    style={{
                      fontSize: "0.65rem",
                      color: "#9ca3af",
                      letterSpacing: "0.04em",
                    }}
                  >
                    GET OUR MOBILE APP FROM
                  </div>
                  <div
                    style={{
                      fontSize: "0.85rem",
                      fontWeight: 700,
                      color: "#fff",
                      lineHeight: 1.1,
                    }}
                  >
                    Google Play Store
                  </div>
                  <div
                    style={{
                      fontSize: "0.7rem",
                      color: "#86efac",
                      letterSpacing: "0.02em",
                    }}
                  >
                    Smart Weather
                  </div>
                </div>
              </a>

              {/* QR Code */}
              <a
                href={PLAY_STORE_URL}
                target="_blank"
                rel="noopener noreferrer"
                title="Scan to download Smart Weather"
                style={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  gap: "0.3rem",
                  padding: "0.4rem",
                  background: "#ffffff",
                  borderRadius: "8px",
                  textDecoration: "none",
                  flexShrink: 0,
                }}
              >
                <img src="/QR.png" alt="Scan to download" style={{ width: 200, height: 200, display: "block", borderRadius: "4px" }}/>
                <span style={{fontSize: "0.6rem", color: "#374151", fontWeight: 600, letterSpacing: "0.03em"}}>
                  SCAN ME
                </span>
              </a>
            </div>

            {/* Social links */}
           {SHOW_SOCIAL_LINKS && (
            <div className="flex items-center gap-3 mt-4">
              <SocialIcon href="#" Icon={Twitter}  label="Twitter" />
              <SocialIcon href="#" Icon={Linkedin} label="LinkedIn" />
              <SocialIcon href="#" Icon={Github}   label="GitHub" />
            </div>
          )}
          </div>

          {/* ── Monitoring column ── */}
          <FooterCol title="Monitoring & Products" icon={Satellite} links={LINKS.monitoring} />

          {/* ── Research column ── */}
          <FooterCol title="Research & Data" icon={BookOpen} links={LINKS.research} />

          {/* ── Community + External ── */}
          <div>
            <FooterCol title="Community Dashboards" icon={Users}     links={LINKS.community} />
            <div className="mt-6">
              <FooterCol title="External Links"  icon={ExternalLink} links={LINKS.external} />
            </div>
          </div>
        </div>
      </div>

      {/* ── Separator ── */}
      <div style={{ borderTop: "1px solid rgba(255,255,255,0.06)" }}>
        <div className="section-container py-5 flex flex-col sm:flex-row items-center justify-between gap-4">
          <div
            className="text-xs text-center sm:text-left shrink-0"
            style={{ color: "var(--footer-text)" }}
          >
            © {new Date().getFullYear()} Space Weather Early Warning Tool Project ·
            Busitema University · All rights reserved.
          </div>

          <div
            className="flex items-center gap-3 text-xs whitespace-nowrap flex-wrap sm:flex-nowrap"
            style={{ color: "var(--footer-text)" }}
          >
            <Link to="/education#glossary" className="footer-link">Glossary</Link>
            <span className="opacity-30">|</span>

            <Link to="/data" className="footer-link">Data Access Policy</Link>
            <span className="opacity-30">|</span>

            <Link to="/alerts" className="footer-link">Alert Definitions</Link>
            <span className="opacity-30">|</span>

            <a
              href="https://www.busitema.ac.ug/"
              target="_blank"
              rel="noopener noreferrer"
              className="footer-link"
            >
              busitema.ac.ug
            </a>
          </div>
        </div>
      </div>

      {/* ── Acknowledgement ribbon ── */}
      <div
        style={{
          background:    'linear-gradient(90deg, var(--busitema-green-dark), var(--busitema-green))',
          padding:       '0.5rem 0',
          textAlign:     'center',
          fontSize:      'var(--text-2xs)',
          color:         'rgba(255,255,255,0.80)',
          letterSpacing: '0.04em',
        }}
      >
        A proud initiative of <strong>Busitema University</strong>.
        Inspired by global best practices from NOAA.
      </div>
    </footer>
  );
}

/* ─── Footer Column ──────────────────────────────────────────── */
function FooterCol({ title, icon: Icon, links }) {
  return (
    <div>
      <div className="flex items-center gap-2 mb-4">
        {Icon && <Icon size={15} style={{ color: 'var(--brand-green)' }} />}
        <h4 style={{ fontSize: 'var(--text-xs)', fontWeight: 700, color: 'var(--footer-title)', letterSpacing: '0.07em', textTransform: 'uppercase' }}>
          {title}
        </h4>
      </div>
      <ul className="space-y-1.5">
        {links.map((link) => (
          <li key={link.label}>
            {link.href ? (
              link.platform ? (
                <a href={link.href} className="footer-link">
                  {link.label}
                </a>
              ) : (
                <a
                href={link.href}
                target="_blank"
                rel="noopener noreferrer"
                className="footer-link"
              >
                {link.label}
              </a>
              )
            ) : (
              <Link to={link.to} className="footer-link">
                {link.label}
              </Link>
            )}
          </li>
        ))}
      </ul>
    </div>
  );
}

/* ─── Social Icon ────────────────────────────────────────────── */
function SocialIcon({ href, Icon, label }) {
  return (
    <a
      href={href}
      aria-label={label}
      className="transition-all"
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        width: "34px",
        height: "34px",
        borderRadius: "50%",
        background: "var(--bg-elevated, rgba(255,255,255,0.06))",
        border: "1px solid var(--border-subtle, rgba(255,255,255,0.1))",
        color: "var(--footer-text)",
      }}
      onMouseEnter={(e) => {
        e.currentTarget.style.background = "rgba(11,102,35,0.25)";
        e.currentTarget.style.color = "var(--busitema-yellow)";
        e.currentTarget.style.borderColor = "rgba(11,102,35,0.4)";
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.background = "var(--bg-elevated, rgba(255,255,255,0.06))";
        e.currentTarget.style.color = "var(--footer-text)";
        e.currentTarget.style.borderColor = "var(--border-subtle, rgba(255,255,255,0.1))";
      }}
    >
      <Icon size={16} />
    </a>
  );
}
